import httpRequest from '../request/indexBase'
import { fetchEventSource } from '@microsoft/fetch-event-source'
import permissionHeader from '@/utils/permissionHeader'
import { local } from '@/utils/storage'
const perModuleType = '0'

// 获取输入字段
export function getBriefByIdApi(params) {
  return httpRequest.get({
    url: `/workflow/exec/getBriefById`,
    params
  })
}

// 获取action字段
export function getActionByIdApi(params) {
  return httpRequest.get({
    url: `/workflow/exec/getActionById`,
    params
  })
}

// 更新action输入
export function updateActionInputApi(data) {
  return httpRequest.post({
    url: `/workflow/exec/updateActionInput`,
    data
  })
}

// 添加自动运行计划
export function addAutoRunningFrequencyApi(data) {
  return httpRequest.post({
    url: `/workflow/task/saveOrUpdateNew`,
    data
  })
}

// 查询自动运行计划
export function getAutoRunningFrequencyApi(params) {
  return httpRequest.get({
    url: `/workflow/workflow-execute-task/getPlanByTaskId`,
    params
  })
}

// 运行脚本
export function runningScriptApi(data) {
  return httpRequest.post({
    url: `/workflow/exec/executeSync`,
    data
  })
}

// 获取脚本运行状态（目前和获取脚本运行的结果一个接口）
export function getWorkflowStatusApi(params) {
  return httpRequest.get({
    url: `/workflow/result/workflowResultPercent`,
    params
  })
}

// 获取脚本运行的结果
export function getWorkflowResultApi(params) {
  return httpRequest.get({
    url: `/workflow/result/workflowResult`,
    params
  })
}

// action重新运行
export function restartActionApi(params) {
  return httpRequest.get({
    url: `/workflow/exec/executeActionByResultId`,
    params
  })
}

// 获取各个action运行的结果
export function getActionResultApi(params) {
  return httpRequest.get({
    url: `/workflow/result/actionResult`,
    params
  })
}

// 获取所有action运行的结果
export function getActionResultListApi(params) {
  return httpRequest.get({
    url: `/workflow/result/actionResultList`,
    params
  })
}

// 查询热点来源
export function getHotListApi(params) {
  return httpRequest.get({
    url: `/workflow/wf-hotspot-config/page`,
    params
  })
}

// 保存个人资料库实体
export function dataLibraryDetailApi(data, perFolderId = '') {
  return httpRequest.post({
    url: `/weaviate/data-library-detail`,
    data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}

// 脚本运行下载
export function scriptDownloadApi(data) {
  return httpRequest.post({
    url: `/workflow/script/download`,
    data,
    responseType: 'blob'
  })
}

// 查询向量库文档
export function queryVectorLibPageApi(params) {
  return httpRequest.get({
    url: `/weaviate/queryVectorLibPage`,
    params
  })
}

// 查询知识库文件
export function queryDataLibPageApi(data) {
  return httpRequest.post({
    url: `/weaviate/data-library-detail/getUserAllReviewDataDetail`,
    data
  })
}

// 修改记录已读未读状态
export function updateRecordStatus(data) {
  return httpRequest.post({
    url: `/workflow/workflow-execute-record/updateMsgReadStatus`,
    data
  })
}
// 修改记录已读未读状态没有id用code
export function updateRecordStatusByCode(data) {
  return httpRequest.post({
    url: `/workflow/workflow-execute-record/updateMsgReadStatusByCode`,
    data
  })
}
// 热点来源最近使用列表
export function getRecentlyUseList() {
  return httpRequest.get({
    url: `/workflow/hotspot/recentlyUseList`
  })
}

// 查询用户热点收藏表
export function getCollectUseList() {
  return httpRequest.get({
    url: `/workflow/wf-hotspot-user-collect/page`
  })
}

// 保存用户热点收藏表
export function saveCollectUse(data) {
  return httpRequest.post({
    url: `/workflow/wf-hotspot-user-collect/refreshList`,
    data
  })
}

// 获取用户授权的小红书账号列表
export function getXhsAccountInfo() {
  return httpRequest.get({
    url: `/user/xhs-account-info/getXhsAccountInfo`
  })
}

// 小红书分享
export function shareVideoNoteToXhs(data) {
  return httpRequest.post({
    url: `/user/xhs-account-info/shareVideoNoteToXhs`,
    data
  })
}

// 查询小红书分享参数
export function getXhsRecordByWorkflowInfoId(params) {
  return httpRequest.get({
    url: `/user/xhs-note-sending-record/getXhsRecordByWorkflowInfoId`,
    params
  })
}

// 根据类型code查询功能预计消耗积分配置
export function getExpectPointsConfigByCode(params) {
  return httpRequest.get({
    url: `/points/feature-expect-points-config/getExpectPointsConfigByCode`,
    params
  })
}
//根据ID修改结果数据
export function updateStoryboardById(data) {
  return httpRequest.post({
    url: '/workflow/workflow-execute-record/updateStoryboardById',
    data
  })
}
//新增聊天
export function addChat(data) {
  return httpRequest.post({
    url: '/chat/global-chat-title',
    data
  })
}
//删除聊天
export function deleteChat(data) {
  return httpRequest.put({
    url: '/chat/global-chat-title/deleteByGlobalTitle',
    data
  })
}
//查询聊天
export function getChatInfo(params) {
  return httpRequest.get({
    url: `/chat/global-chat-title/${params.id}`
  })
}
//查询聊天记录
export function getRecord(params) {
  return httpRequest.get({
    url: `/chat/global-chat-record/globalChatRecordList/${params.globalChatTitleId}`
  })
}
// 修改聊天实体信息
export function updateChatInfo(data) {
  return httpRequest.put({
    url: `/chat/global-chat-title`,
    data
  })
}
// 发送会话
export function sendChat(data, onopen, onmessage, onclose, onerror) {
  const ctrl = new AbortController()
  return fetchEventSource(
    process.env.VUE_APP_API_URL + '/chat/global-chat-record/globalChatCompletion',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/event-stream',
        token: local.get('TOKEN'),
        ...permissionHeader()
      },
      body: JSON.stringify(data),
      signal: ctrl.signal,
      openWhenHidden: true,
      onopen(response) {
        // 开启流
        console.log('onopen')

        onopen && onopen(response)
      },
      onmessage(event) {
        // 监听流
        onmessage && onmessage(event)
      },
      onclose(e) {
        // 关闭流
        onclose && onclose(e)
      },
      onerror: (e) => {
        //返回流报错
        onerror && onerror(e)
        throw e
      }
    }
  )
}

export function queryChatRecord(params) {
  return httpRequest.get({
    url: `/chat/workflow-chat-record/workFlowChatList/${params.id}`
  })
}

//根据类型编码查询工作流
export function getWorkflowByTypeCode(params) {
  return httpRequest.get({
    url: `/workflow/workflow-info/getWorkflowByTypeCode`,
    params
  })
}

export function sendChatInResult(data, onopen, onmessage, onclose, onerror) {
  const ctrl = new AbortController()
  return fetchEventSource(
    process.env.VUE_APP_API_URL + '/chat/workflow-chat-record/workFlowChatCompletion',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/event-stream',
        token: local.get('TOKEN'),
        ...permissionHeader()
      },
      body: JSON.stringify(data),
      signal: ctrl.signal,
      openWhenHidden: true,
      onopen(response) {
        // 开启流
        console.log('onopen')

        onopen && onopen(response)
      },
      onmessage(event) {
        // 监听流
        onmessage && onmessage(event)
      },
      onclose(e) {
        // 关闭流
        onclose && onclose(e)
      },
      onerror: (e) => {
        //返回流报错
        onerror && onerror(e)
        throw e
      }
    }
  )
}
